// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2gqUU","legacyBtn":"MutateMid_legacyBtn__2KZ7A"};